import Email from 'components/email';
import Riepilogo from 'components/riepilogo';
import Text from 'components/text';
import { dateFormat, dateTimeFormat } from 'helpers/utils';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Button, Col, Modal, OverlayTrigger, Row, Table, Toast, Tooltip } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getAvvioCertificazione, getCertificazioneEmail, getDettaglioCertificazione, getLogCedcri, inviaEmail, resetResultAvvioCertificazione, resetResultInvioMail } from './_redux/actions';
import { dettaglioCertificazioneSelector, logCedacriSelector, resultAvvioCertificazioneSelector, resultInvioEmailSelector, storicoSmsCertificazioneEmailSelector } from './_redux/selector';



interface RouteParams {
  id: string
}

const DettaglioCertificazione: React.VFC = () => {
  const dispatch = useAppDispatch();
  const dettaglioCertif = useAppSelector(dettaglioCertificazioneSelector);
  const storicoSmsCertificazioneEmail = useAppSelector(storicoSmsCertificazioneEmailSelector);
  const resultAvviaCertificazione = useAppSelector(resultAvvioCertificazioneSelector);
  const resultInviaEmail = useAppSelector(resultInvioEmailSelector);
  const logCedacri = useAppSelector(logCedacriSelector);
  const [showModalSms, setShowModalSms] = useState(false);
  const { id } = useParams<RouteParams>();
  const [testoEmail, setTestoEmail] = useState<string>('');
  const [modalAvviaCertificazione, setModalAvviaCertificazione] = useState<boolean>(false);
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
  const [showEmailToast, setShowEmailToast] = useState<boolean>(false);
  const [showEmailModal, setShowEmailModal] = useState<boolean>(false);
  const [showModalLogCedacri, setShowModalLogCedacri] = useState<boolean>(false);
  const [idEmailtoSend, setIdEmailToSend] = useState<number>(0);

  const openModalSms = (id: number) => {
    dispatch(getCertificazioneEmail(id));
    setShowModalSms(true);
  }

  const openModalEmail = (testoEmail: string) => {
    localStorage.removeItem('accessTokenCliente');
    setTestoEmail(testoEmail);
    // setShowModalEmail(true);
  }
  const openModalSendEmail = (id: number) => {
    setShowEmailModal(true);
    setIdEmailToSend(id);
  }

  const openModalLogCedagri = () => {
    if (dettaglioCertif.certificazione?.id) {
      setShowModalLogCedacri(true)
      dispatch(getLogCedcri(dettaglioCertif.certificazione?.id))
    }

  }


  useEffect(() => {
    dispatch(getDettaglioCertificazione(parseInt(id)))
  }, [dispatch, id]);

  const avviaCertificazione = () => {
    if (dettaglioCertif?.certificazione?.idCertificazioneEmailAvviaCertificazione) {
      dispatch(getAvvioCertificazione(dettaglioCertif.certificazione.idCertificazioneEmailAvviaCertificazione))
    }
  }

  useEffect(() => {
    if (resultAvviaCertificazione) {
      setModalAvviaCertificazione(false)
      setShowSuccessModal(true)
      dispatch(getDettaglioCertificazione(parseInt(id)));
      dispatch(resetResultAvvioCertificazione())
      //dispatch(getElencoCertificazioniCliente(parseInt(ndg)));
      setTimeout(() => {
        setShowSuccessModal(false)
      }, 3000);
    }
  }, [resultAvviaCertificazione])

  useEffect(() => {
    if (resultInviaEmail) {
      setShowEmailToast(true);
      dispatch(getDettaglioCertificazione(parseInt(id)));
      dispatch(resetResultInvioMail());
    }
  }, [resultInviaEmail])

  const popoverLogCedacri = (
    <Tooltip id="popover-trigger-focus" title="Popover bottom">
      Questa sezione è strettamente tecnica e va consultata per dare dettagli aggiuntivi per l'apertura del ticket all'assistenza tecnica
    </Tooltip>
  );

  return (

    <div>
      <Row className="mb-3">
        <Col>
          <Text title="Dettaglio certificazione" type='sottotitolo' />
        </Col>
      </Row>
      {dettaglioCertif && dettaglioCertif?.certificazione && (

        <div className="mb-3">
          <Row>
            <Col md={4} className="mb-2">
              <Riepilogo chiave='Id certificazione' valore={dettaglioCertif.certificazione?.id} />
            </Col>
            <Col md={4} className="mb-2">
              <Riepilogo chiave='NDG' valore={dettaglioCertif.certificazione?.ndg} />
            </Col>
            <Col md={4} className="mb-2">
              <Riepilogo chiave='Nominativo' valore={dettaglioCertif.certificazione?.nominativo} />
            </Col>
            <Col md={4} className="mb-2">
              <Riepilogo chiave='Filiale prevalente' valore={dettaglioCertif.certificazione?.filialeNdg} />
            </Col>
            <Col md={4} className="mb-2">
              <Riepilogo chiave='Stato certificazione' valore={dettaglioCertif.certificazione?.statoCertificazioneDesc} isValueHighlighed={true} />
            </Col>
            <Col md={4} className="mb-2">
              <Riepilogo chiave='Modalità certificazione' valore={dettaglioCertif.certificazione?.modalitaCertificazioneDesc} />
            </Col>
            <Col md={4} className="mb-2">
              <Riepilogo chiave='Processo' valore={dettaglioCertif.certificazione?.workFlowCertificazioneNome} />
            </Col>
            <Col md={4} className="mb-2">
              <Riepilogo chiave='Tipo certificazione' valore={(dettaglioCertif.certificazione.isCertificazioneFromLotto ?? false) ? "Massiva" : "On boarding"} />
            </Col>
            <Col md={4} className="mb-2">
              <Riepilogo chiave='Data inserimento' valore={dateFormat(dettaglioCertif.certificazione?.dataInserimento)} />
            </Col>
            <Col md={4} className="mb-2">
              <Riepilogo chiave='Date inserimento Anagrafe Cedacri' valore={dateFormat(dettaglioCertif.certificazione?.dataInserimentoAnagrafeCedacri)} />
            </Col>
            <Col md={4} className="mb-2">
              <Riepilogo chiave='Data ultima modifica' valore={dateFormat(dettaglioCertif.certificazione?.dataUltimaModifica)} />
            </Col>
            <Col md={4} className="mb-2">
              <Riepilogo chiave='Cellulare Anagrafe' valore={dettaglioCertif.certificazione?.cellulareAnagrafe} />
            </Col>
            <Col md={4} className="mb-2">
              <Riepilogo chiave='Cellulare Home Banking' valore={dettaglioCertif.certificazione?.cellulareHomeBanking} popoverMessage="Le informazioni relative ai contatti home banking sono disponibili solo se il processo ha avuto inizio dal batch notturno poichè l'anagrafe Cedacri non restituisce questo tipo di informazioni." />
            </Col>
            <Col md={4} className="mb-2">
            </Col>
            <Col md={12} className="mb-2">
              <Riepilogo chiave='Email Anagrafe' valore={dettaglioCertif.certificazione?.emailAnagrafe} />
            </Col>
            <Col md={12} className="mb-2">
              <Riepilogo chiave='Email Home Banking' valore={dettaglioCertif.certificazione?.emailHomeBanking} popoverMessage="Le informazioni relative ai contatti home banking sono disponibili solo se il processo ha avuto inizio dal batch notturno poichè l'anagrafe Cedacri non restituisce questo tipo di informazioni." />
            </Col>
            <Col md={12} className="mb-2">
              <Riepilogo chiave='Email FEA' valore={dettaglioCertif.certificazione?.emailFirmaBiometricaAnagrafe} />
            </Col>
            <Col md={12} className="mb-2">
              <Riepilogo chiave='Operatore' valore={dettaglioCertif.certificazione?.matricolaOperatore && dettaglioCertif.certificazione?.nominativoOperatore ? dettaglioCertif.certificazione?.matricolaOperatore + " - " + dettaglioCertif.certificazione?.nominativoOperatore +
                (dettaglioCertif.certificazione?.filialeOperatore && dettaglioCertif.certificazione?.tipoProfiloOperatore ? " - " + dettaglioCertif.certificazione?.tipoProfiloOperatore + " - " + dettaglioCertif.certificazione?.filialeOperatore : "") : "-"} />
            </Col>
            <Col md={12} className="mb-2">
              <Riepilogo chiave='Motivazione richiesta certificazione' valore={dettaglioCertif.certificazione?.motivazioneRichiestaCertificazione} />
            </Col>
            <Col md={12} className="mb-2 icon-table">
              {dettaglioCertif.certificazione?.hasLogCedacri &&
                <OverlayTrigger
                  placement="bottom-end"
                  delay={{ show: 250, hide: 400 }}
                  overlay={popoverLogCedacri}>
                  <Button variant="link" className="button" onClick={openModalLogCedagri}><i className="fas fa-clipboard-list pr-1" title="Log Cedacri" ></i>Log anagrafica Cedacri</Button>
                </OverlayTrigger>
              }
            </Col>
          </Row>
        </div>
      )}

      <Row className="mb-3">
        <Col className="text-center">
          {dettaglioCertif?.certificazione?.hasAvviaCertificazione && <Button onClick={() => setModalAvviaCertificazione(true)}>Avvia Certificazione</Button>}
          <hr />
        </Col>
      </Row>
      <Toast delay={3000} autohide show={showEmailToast} onClose={() => setShowEmailToast(false)}
        style={{
          position: 'absolute',
          top: 74,
          right: 0,
        }}
      >
        <Toast.Header closeButton={false}><strong>Email inviata</strong></Toast.Header>
        <Toast.Body>L'email è stata inviata con successo</Toast.Body>
      </Toast>
      <Row className="mb-3">
        <Col md={12}>
          <Text title="Dettaglio Certificazione Email" type="sottotitolo"></Text>
        </Col>
      </Row>
      < Row >
        <Col md="12">
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Stato certificazione</th>
                <th>Data certificazione</th>
                <th>Data inserimento</th>
                <th>Data ultima modifica</th>
                <th>Email certificazione</th>
                <th>Cellulare certificazione</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {dettaglioCertif?.certificazioniEmail && dettaglioCertif?.certificazioniEmail.map((arr, index) => (
                <tr key={index}>
                  <td>{arr.statoCertificazioneDesc}</td>
                  <td>
                    <label className="mb-0">{dateTimeFormat(arr.dataCertificazione)}</label>
                  </td>
                  <td>
                    <label className="mb-0">{dateTimeFormat(arr.dataInserimento)}</label>
                  </td>
                  <td>
                    <label className="mb-0">{dateTimeFormat(arr.dataUltimaModifica)}</label>
                  </td>
                  <td>{arr.emailCertificazione}</td>
                  <td>{arr.cellulareCertificazione}</td>
                  <td className="d-flex justify-content-around icon-table">
                    <div>
                      <Button variant="link" className="" onClick={() => arr.testoEmail ? openModalEmail(arr.testoEmail) : null} disabled={arr.isInviata === 0}><i className="fas fa-search-plus" title="Anteprima Email"></i></Button>
                      <Button variant="link" className="" onClick={() => arr.id ? openModalSms(arr.id) : null}><i className="fas fa-info-circle" title="Storico Sms"></i></Button>
                      {arr.idStatoCertificazione === 4 && (
                        <Button variant="link" className="" onClick={() => arr.id ? openModalSendEmail(arr.id) : null}><i className="fas fa-paper-plane" title="Invia Email"></i></Button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
              {dettaglioCertif?.certificazioniEmail?.length === 0 && (
                <tr key={-1}>
                  <td colSpan={9} className="text-center"><Text title="Nessun risultato presente" /></td>
                </tr>
              )}
            </tbody>
          </Table>
        </Col>
      </Row>

      <Modal
        size="lg"
        show={showModalSms}
        onHide={() => setShowModalSms(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Storico SMS
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>Cellulare certificazione</th>
                    <th>Testo sms</th>
                    <th>Stato</th>
                    <th>Data invio sms</th>
                    <th>Data scadenza token</th>
                  </tr>
                </thead>
                <tbody>
                  {storicoSmsCertificazioneEmail.map((arr, index) => (
                    <tr key={index}>
                      <td>{arr.cellulareCertificazione}</td>
                      <td>{arr.testoSms}</td>
                      <td>{arr.statoCertificazioneDesc}</td>
                      <td>{dateTimeFormat(arr.dataInvioSms)}</td>
                      <td>{dateTimeFormat(arr.dataScadenzaToken)}</td>
                    </tr>
                  ))}
                  {storicoSmsCertificazioneEmail.length === 0 && (
                    <tr>
                      <td colSpan={6} className="text-center">Non è presente nessun SMS</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={!!testoEmail}
        onHide={() => setTestoEmail('')}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Anteprima Email
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Email testoEmail={testoEmail} />
        </Modal.Body>
      </Modal>
      <Modal
        show={showSuccessModal}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Text title="Certificazione avviata con successo" type="titolo"></Text>
            <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
              <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
              <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
            </svg>
          </div>
        </Modal.Body>
      </Modal>


      <Modal
        show={modalAvviaCertificazione}
        onHide={() => setModalAvviaCertificazione(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Avvia Certificazione</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Sei sicuro di voler avviare la certificazione?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={avviaCertificazione}>Avvia Certificazione</Button>
          <Button variant="secondary" onClick={() => setModalAvviaCertificazione(false)}>Chiudi</Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showEmailModal}
        onHide={() => setShowEmailModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Invia Email</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Sei sicuro di voler inviare una nuova Email?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => { dispatch(inviaEmail(idEmailtoSend)); setShowEmailModal(false) }}>Invia Email</Button>
          <Button variant="secondary" onClick={() => setShowEmailModal(false)}>Chiudi</Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showModalLogCedacri}
        onHide={() => setShowModalLogCedacri(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Log Cedacri</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md="12">
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    {/* <th>Id</th> */}
                    <th>Id certificazione</th>
                    <th>Log risposta anagrafe cedacri</th>
                    <th>Log anagrafe cedacri</th>
                    <th>Data inserimento</th>
                  </tr>
                </thead>
                <tbody>
                  {logCedacri?.map((arr, index) => (
                    <tr key={index}>
                      {/* <td>{arr.id}</td> */}

                      <td className="icon-table">{arr.containsErrors === 1 && <i className="fas fa-exclamation-triangle mr-3"></i>}{arr.idCertificazione}</td>
                      <td>{arr.logRispostaAnagrafeCedacri}</td>
                      <td>{arr.logAnagrafeCedacri}</td>
                      <td>{dateTimeFormat(arr.dataInserimento)}</td>
                    </tr>
                  ))}
                  {logCedacri === undefined || logCedacri?.length === 0 && (
                    <tr>
                      <td colSpan={5} className="text-center">Non è presente nessun Log</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalLogCedacri(false)}>Chiudi</Button>
        </Modal.Footer>
      </Modal>
    </div >
  )

}
export default DettaglioCertificazione;
